/* ============================================================================
FILE: po-katupirsia5-humanus-texts-fr-en-es-20260319.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5HumanusTextsFR_EN_ES_20260319
ROOT: .po-k5-section[data-po-k5="humanus"]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- gestion séparée des médias titre / chips
- Humanus : uniquement les images nécessaires
  * titre = idéogramme conceptuel
  * chip 1 = idéogramme fonctionnel
  * chip 2 = fonction posœnnoïale
  * chip 3 = masqué si vide
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_HUMANUS_TEXTS_20260319__) return;
  window.__PO_K5_HUMANUS_TEXTS_20260319__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="humanus"]';

  var HUMANUS_CONCEPT_URL =
    "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Humanus_conceptuel.png?v=1774459599";
  var HUMANUS_FUNCTION_URL =
    "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Humanus_fonctionel.png?v=1774459886";
  var HUMANUS_POFUNCTION_URL =
    "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Humanus_fonction_posoennoiale.png?v=1774459886";

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function escapeHTML(s) {
    return clampStr(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    if (v.indexOf("pt") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}

    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}

    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var htmlLang = document && document.documentElement
        ? document.documentElement.getAttribute("lang") || ""
        : "";
      var fromHtml = normLang(htmlLang);
      if (fromHtml) return fromHtml;
    } catch (e) {}

    try {
      var navLang = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(navLang);
      if (v) return v;
    } catch (e) {}

    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen) {
    var key = String(v || "");
    if (!key) return;
    if (seen) {
      if (seen[key]) return;
      seen[key] = true;
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === key) return;
      }
    }
    arr.push(key);
  }

  function buildVariants(term) {
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1, seen);
    uniqPush(out, oe2, seen);
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Humanus",
      "Humanus humanitas",
      "Âṣẹxel’Or",
      "Souffle d’Or",
      "Numéris",
      "Δτ",
      "Année posœnnoïale",
      "AP",
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "RéZonans",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Posœnnoïamie",
      "Posœnnomia",
      "Sceau d’Équiphase",
      "Isqun",
      "Threnisqun",
      "Tiqqunbahu",
      "Takimarah",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Conscientisation dynamique",
      "Conscientisation introspective",
      "Conscience vibratoire",
      "Sujet pluriel",
      "Addition synchrêtique",
      "Superposition de perspectives",
      "Extratinrieur",
      "Extratinriorialiser",
      "Fréquence 492",
      "Fréquence-guide"
    ];
  }

  var CANONICAL_OVERRIDES = [
    [/\bGuide-number\b/gi, "Nombre-guide"],
    [/\bGuide number\b/gi, "Nombre-guide"],
    [/\bGuide-frequency\b/gi, "Fréquence-guide"],
    [/\bGuide frequency\b/gi, "Fréquence-guide"],
    [/\bN[uú]mero-gu[ií]a\b/gi, "Nombre-guide"],
    [/\bFrecuencia-gu[ií]a\b/gi, "Fréquence-guide"],
    [/\bFrequency 492\b/gi, "Fréquence 492"],
    [/\bFrecuencia 492\b/gi, "Fréquence 492"],
    [/\bOperative memory\b/gi, "Mémoire opérative"],
    [/\bMemoria operativa\b/gi, "Mémoire opérative"],
    [/\bFunctional ideogram\b/gi, "Idéogramme fonctionnel"],
    [/\bIdeograma funcional\b/gi, "Idéogramme fonctionnel"],
    [/\bPosœnno[iï]al function\b/gi, "Fonction posœnnoïale"],
    [/\bFunci[oó]n posœnno[iï]al\b/gi, "Fonction posœnnoïale"],
    [/\bPosœnno[iï]al Year\b/gi, "Année posœnnoïale"],
    [/\bA[nñ]o posœnno[iï]al\b/gi, "Année posœnnoïale"],
    [/\bbreath of gold\b/gi, "Souffle d’Or"],
    [/\baliento de oro\b/gi, "Souffle d’Or"],
    [/\bVibratory consciousness\b/gi, "Conscience vibratoire"],
    [/\bConciencia vibratoria\b/gi, "Conscience vibratoire"],
    [/\bPosœnno[iï]al meditations\b/gi, "Méditations Posœnnoïales"],
    [/\bMeditaciones posœnno[iï]ales\b/gi, "Méditations Posœnnoïales"],
    [/\bPosœnno[iï]al agreements\b/gi, "Accords Posœnnoïaux"],
    [/\bAcuerdos posœnno[iï]aux\b/gi, "Accords Posœnnoïaux"]
  ];

  function enforceCanonicalFrench(src) {
    var out = clampStr(src);
    if (!out) return "";
    for (var i = 0; i < CANONICAL_OVERRIDES.length; i++) {
      out = out.replace(CANONICAL_OVERRIDES[i][0], CANONICAL_OVERRIDES[i][1]);
    }
    return out;
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    var seen = Object.create(null);

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) {
        uniqPush(variants, list[j], seen);
      }
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    if (!parts.length) return null;

    try {
      return new RegExp("(" + parts.join("|") + ")", "g");
    } catch (e) {
      return null;
    }
  }

  var __PO_PROTECT_RE__ = null;

  function protectLexiconInHTML(html) {
    var src = enforceCanonicalFrench(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (!__PO_PROTECT_RE__) return src;

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect notranslate">' + m + '</span>';
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(escapeHTML(enforceCanonicalFrench(txt)));
  }

  function syncMediaWrapper(el) {
    if (!el) return;
    var media = el.closest(".po-axis-title__media, .po-axis-chip__media");
    if (!media) return;

    if (el.hasAttribute("hidden")) {
      media.setAttribute("hidden", "");
    } else {
      media.removeAttribute("hidden");
    }
  }

  function setImg(el, data) {
    if (!el) return;

    var src = data && data.src ? data.src : "";
    var alt = enforceCanonicalFrench(data && data.alt ? data.alt : "");

    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
    } else {
      el.setAttribute("hidden", "");
      el.removeAttribute("src");
      el.alt = "";
    }

    syncMediaWrapper(el);
  }

  function toggleTitleMedia(root) {
    if (!root) return;
    var img = root.querySelector('[data-po-slot="title_img"]');
    if (!img) return;
    syncMediaWrapper(img);
  }

  function toggleChipBlocks(root) {
    if (!root) return;

    var blocks = root.querySelectorAll(".po-axis-chipblock");
    for (var i = 0; i < blocks.length; i++) {
      var block = blocks[i];
      var label = block.querySelector(".po-axis-chip");
      var img = block.querySelector(".po-axis-chip__img");
      var hasLabel = !!clampStr(label && label.textContent).trim();
      var hasImg = !!(img && !img.hasAttribute("hidden") && clampStr(img.getAttribute("src")).trim());

      if (!hasLabel && !hasImg) block.setAttribute("hidden", "");
      else block.removeAttribute("hidden");
    }
  }

  var CONTENT = {
    fr: {
      title: "Humanus",
      kicker: "Unité de conscience en syntonie avec le vivant — interface capteur–diffuseur du passage.",
      title_img: { src: HUMANUS_CONCEPT_URL, alt: "Idéogramme conceptuel de Humanus" },
      h_def: "Définition canonique",
      chip_1: "Idéogramme fonctionnel",
      chip_1_img: { src: HUMANUS_FUNCTION_URL, alt: "Idéogramme fonctionnel de Humanus" },
      chip_2: "Fonction posœnnoïale",
      chip_2_img: { src: HUMANUS_POFUNCTION_URL, alt: "Fonction posœnnoïale de Humanus" },
      chip_3: "",
      chip_3_img: { src: "", alt: "" },
      def_short: "Le <strong>Humanus</strong> désigne l’unité de conscience en syntonie avec le vivant, traversée par la lumière comme onde opérative.",
      def_long:
        "<p><strong>Humanus</strong> nomme l’humain en tant qu’interface capteur–diffuseur. La perception n’y relève pas d’une réception passive : elle constitue déjà un passage. La respiration n’y relève pas d’une simple nécessité biologique : elle devient un acte de redistribution. Voir revient à être traversé, respirer revient à moduler et transmettre.</p>" +
        "<p>Dans K9, <strong>Humanus</strong> apparaît comme lieu d’inscription du vrai temps : la lumière reçue s’y dépose comme fragment de temporalité juste, à tenir sans appropriation ni rigidification. Dans une œuvre, un texte, une interface ou une pratique, il déplace le centre de lecture : on n’opère plus sur \"l’humain\", on opère depuis l’humain comme zone de passage.</p>",
      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Concept (K9 – Fondements)",
      grid_freq_label: "Nombre-guide",
      grid_freq_value: "—",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
          "<li>Perception comme interface du passage</li>" +
          "<li>Souffle comme redistribution et tenue</li>" +
          "<li>Inscription du vrai temps dans le corps et la conscience</li>" +
          "<li>Geste simple de tenue pour rendre la transformation habitable</li>" +
          "<li>Usage dans l’œuvre, le texte, l’interface et la pratique</li>" +
        "</ul>",
      h_intro: "Ce que nomme Humanus",
      p_intro:
        "<p><strong>Humanus</strong> désigne l’humain comme interface capteur–diffuseur. L’œil, l’écoute, l’attention, le toucher et le souffle deviennent des instruments d’accord : voir revient à être traversé, respirer revient à moduler et transmettre.</p>" +
        "<p>Le terme est conservé sous sa forme latine afin de marquer un déplacement décisif : il ne s’agit pas d’une définition abstraite de l’humain, mais d’une tenue opérative de l’expérience vécue, où lumière, rythme et conscience deviennent passage.</p>" +
        "<p>Dans la logique de l’<strong>Humanus humanitas</strong>, la singularité vécue et l’horizon collectif se rejoignent dans une même habitation du vivant.</p>",
      h_actions: "Fonctionnement opératif",
      actions:
        "<ol>" +
          "<li>Repérer le point de perception qui sert d’interface au passage : œil, écoute, toucher, attention.</li>" +
          "<li>Identifier le rythme qui rend la transformation habitable : souffle, cadence, pause, densité.</li>" +
          "<li>Recevoir le fragment de lumière-temps sans le figer : accueillir ce qui traverse sans appropriation.</li>" +
          "<li>Choisir un geste simple de tenue : phrase, forme, réglage, acte bref, posture ou respiration orientée.</li>" +
          "<li>Redistribuer ce reçu dans la conscience, le corps, la relation ou l’œuvre afin que le passage demeure praticable.</li>" +
        "</ol>",
      h_phrase: "Phrase opérative",
      phrase: "<p>« Humanus : je perçois, je respire, et le passage devient habitable. »</p>",
      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Humanus",
      table_rows:
        "<tr><td>Passage intérieur à tenir</td><td>Émotion, lumière, mémoire ou clarté en cours de dépôt</td><td>Transformer la réception en souffle, puis le souffle en tenue</td></tr>" +
        "<tr><td>Lecture d’une œuvre ou d’un texte</td><td>Décentrement du regard, apparition d’un seuil sensible</td><td>Opérer depuis l’humain comme interface de passage</td></tr>" +
        "<tr><td>Temps vécu en déséquilibre</td><td>Compression, saturation, excès d’intensité ou dispersion</td><td>Rendre le passage habitable par le rythme, le souffle et l’ajustement</td></tr>" +
        "<tr><td>Travail corporel ou méditatif</td><td>Besoin de réaccorder perception, respiration et conscience</td><td>Faire du souffle un instrument d’accord et de redistribution</td></tr>",
      h_entite: "Liens internes",
      entite_kicker: "Entrée contenue dans Âṣẹxel’Or",
      entite_body:
        "<p><strong>Humanus</strong> entretient des liens directs avec <strong>Âṣẹxel’Or</strong>, <strong>Souffle d’Or</strong>, <strong>Δτ</strong>, <strong>Numéris</strong> et l’<strong>Année posœnnoïale</strong> (<strong>AP</strong>). Dans cette constellation, la respiration porte le passage, le seuil temporel le règle, le nombre en donne une lecture fréquentielle, et le cycle inscrit l’expérience dans une pratique.</p>" +
        "<p>L’axe est net : <strong>Souffle d’Or</strong> respire, <strong>Humanus</strong> habite ; <strong>Δτ</strong> ouvre le seuil, <strong>Humanus</strong> le tient ; <strong>Numéris</strong> mesure, <strong>Humanus</strong> résonne ; l’<strong>Année posœnnoïale</strong> structure, <strong>Humanus</strong> incarne.</p>",
      h_ritual: "Micro-rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Perception – souffle – geste de tenue",
      ritual_steps:
        "<ol>" +
          "<li>Se placer dans un moment de clarté sensible, de trouble, de bascule ou de réception.</li>" +
          "<li>Nommer silencieusement le point de perception actif : regard, écoute, peau, souffle, attention.</li>" +
          "<li>Inspirer lentement en laissant entrer le fragment reçu sans le juger ni le fermer.</li>" +
          "<li>Expirer en choisissant un geste simple de tenue : une phrase, une note, un tracé, un réglage, une orientation du corps.</li>" +
          "<li>Clore par la phrase opérative afin que le passage devienne habitable plutôt qu’écrasant.</li>" +
        "</ol>",
      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
          "<li>Lecture d’un texte ou d’une œuvre où quelque chose demande à être reçu avant d’être analysé</li>" +
          "<li>États de saturation, d’éblouissement, de trouble ou de densification intérieure</li>" +
          "<li>Travail sur la respiration comme principe de redistribution</li>" +
          "<li>Phases de réglage entre perception, corps, rythme et conscience</li>" +
          "<li>Passages où l’on cherche moins à définir l’humain qu’à l’habiter comme seuil</li>" +
        "</ul>",
      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
          "<li><strong>Katûvýs</strong> — matrice-substrat où baignent les intensités reçues</li>" +
          "<li><strong>Katûvýsissence</strong> — mémoire de traversée et dépôt des ajustements</li>" +
          "<li><strong>Méditations Posœnnoïales</strong> — exercice de clarté intime et d’intégration du souffle</li>" +
          "<li><strong>Accords Posœnnoïaux</strong> — inscription relationnelle et collective de l’expérience</li>" +
          "<li><strong>Numéris</strong> — lecture fréquentielle du vécu</li>" +
          "<li><strong>Δτ</strong> — tenue du seuil et respiration du vrai temps</li>" +
          "<li><strong>Conscience vibratoire</strong> — calibration de l’accord entre corps, perception et milieu</li>" +
        "</ul>",
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Humanus",
      kicker: "Unit of consciousness in resonance with the living — sensing–diffusing interface of passage.",
      title_img: { src: HUMANUS_CONCEPT_URL, alt: "Idéogramme conceptuel de Humanus" },
      h_def: "Canonical definition",
      chip_1: "Functional ideogram",
      chip_1_img: { src: HUMANUS_FUNCTION_URL, alt: "Idéogramme fonctionnel de Humanus" },
      chip_2: "Posœnnoïal function",
      chip_2_img: { src: HUMANUS_POFUNCTION_URL, alt: "Fonction posœnnoïale de Humanus" },
      chip_3: "",
      chip_3_img: { src: "", alt: "" },
      def_short: "<strong>Humanus</strong> designates the unit of consciousness in resonance with the living, traversed by light as an operative wave.",
      def_long:
        "<p><strong>Humanus</strong> names the human as a sensing–diffusing interface. Perception is no passive reception there: it is already a passage. Breathing is no mere biological necessity there: it becomes an act of redistribution. To see is already to be traversed, to breathe is to modulate and transmit.</p>" +
        "<p>In K9, <strong>Humanus</strong> appears as the place where true time is inscribed: received light settles there as a fragment of just temporality, to be held without appropriation or rigidification. In a work, a text, an interface, or a practice, it shifts the reading center: one no longer operates on the human, but from the human as a zone of passage.</p>",
      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Concept (K9 – Foundations)",
      grid_freq_label: "Guide-number",
      grid_freq_value: "—",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
          "<li>Perception as the interface of passage</li>" +
          "<li>Breath as redistribution and hold</li>" +
          "<li>Inscription of true time in body and consciousness</li>" +
          "<li>Simple holding gesture to make transformation habitable</li>" +
          "<li>Use in the work, the text, the interface, and the practice</li>" +
        "</ul>",
      h_intro: "What Humanus names",
      p_intro:
        "<p><strong>Humanus</strong> designates the human as a sensing–diffusing interface. Eye, listening, attention, touch, and breath become tuning instruments: to see is to be traversed, to breathe is to modulate and transmit.</p>" +
        "<p>The term remains in its Latin form to mark a decisive displacement: this is not an abstract definition of the human, but an operative hold of lived experience, where light, rhythm, and consciousness become passage.</p>" +
        "<p>In the logic of <strong>Humanus humanitas</strong>, lived singularity and collective horizon meet within the same inhabitation of the living.</p>",
      h_actions: "Operative functioning",
      actions:
        "<ol>" +
          "<li>Identify the point of perception serving as the interface of passage: eye, listening, touch, attention.</li>" +
          "<li>Identify the rhythm that makes transformation habitable: breath, cadence, pause, density.</li>" +
          "<li>Receive the fragment of light-time without freezing it: welcome what passes through without appropriation.</li>" +
          "<li>Choose one simple holding gesture: phrase, form, setting, brief act, posture, or oriented breath.</li>" +
          "<li>Redistribute what was received into consciousness, body, relation, or work so that passage remains practicable.</li>" +
        "</ol>",
      h_phrase: "Operative phrase",
      phrase: "<p>“Humanus: I perceive, I breathe, and the passage becomes habitable.”</p>",
      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action of Humanus",
      table_rows:
        "<tr><td>Inner passage to be held</td><td>Emotion, light, memory, or clarity settling in</td><td>Transform reception into breath, then breath into hold</td></tr>" +
        "<tr><td>Reading a work or a text</td><td>Decentered gaze, emergence of a sensitive threshold</td><td>Operate from the human as an interface of passage</td></tr>" +
        "<tr><td>Lived time in disequilibrium</td><td>Compression, saturation, excess intensity, or dispersion</td><td>Make passage habitable through rhythm, breath, and adjustment</td></tr>" +
        "<tr><td>Body or meditative work</td><td>Need to retune perception, breathing, and consciousness</td><td>Make breath an instrument of tuning and redistribution</td></tr>",
      h_entite: "Internal links",
      entite_kicker: "Entry contained in Âṣẹxel’Or",
      entite_body:
        "<p><strong>Humanus</strong> maintains direct links with <strong>Âṣẹxel’Or</strong>, <strong>Souffle d’Or</strong>, <strong>Δτ</strong>, <strong>Numéris</strong>, and the <strong>Année posœnnoïale</strong> (<strong>AP</strong>). Within this constellation, breathing carries passage, the temporal threshold regulates it, number offers a frequency-based reading of it, and the cycle inscribes experience into practice.</p>" +
        "<p>The axis is clear: <strong>Souffle d’Or</strong> breathes, <strong>Humanus</strong> inhabits; <strong>Δτ</strong> opens the threshold, <strong>Humanus</strong> holds it; <strong>Numéris</strong> measures, <strong>Humanus</strong> resonates; the <strong>Année posœnnoïale</strong> structures, <strong>Humanus</strong> embodies.</p>",
      h_ritual: "Micro-activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Perception – breath – holding gesture",
      ritual_steps:
        "<ol>" +
          "<li>Stand within a moment of sensitive clarity, trouble, shift, or reception.</li>" +
          "<li>Silently name the active point of perception: gaze, listening, skin, breath, attention.</li>" +
          "<li>Inhale slowly, letting the received fragment enter without judging it or closing it.</li>" +
          "<li>Exhale while choosing one simple holding gesture: a phrase, a note, a trace, a setting, a bodily orientation.</li>" +
          "<li>Close with the operative phrase so that passage becomes habitable rather than overwhelming.</li>" +
        "</ol>",
      h_moments: "Privileged moments",
      moments:
        "<ul>" +
          "<li>Reading a text or a work where something asks to be received before being analyzed</li>" +
          "<li>States of saturation, dazzlement, trouble, or inner densification</li>" +
          "<li>Work on breathing as a principle of redistribution</li>" +
          "<li>Phases of adjustment between perception, body, rhythm, and consciousness</li>" +
          "<li>Passages where one seeks less to define the human than to inhabit it as threshold</li>" +
        "</ul>",
      h_syntony: "Katûvýsian syntonies",
      syntony:
        "<ul>" +
          "<li><strong>Katûvýs</strong> — matrix-substratum where received intensities bathe</li>" +
          "<li><strong>Katûvýsissence</strong> — memory of traversal and deposit of adjustments</li>" +
          "<li><strong>Méditations Posœnnoïales</strong> — exercise of intimate clarity and integration of breath</li>" +
          "<li><strong>Accords Posœnnoïaux</strong> — relational and collective inscription of the experience</li>" +
          "<li><strong>Numéris</strong> — frequency-based reading of lived experience</li>" +
          "<li><strong>Δτ</strong> — holding of the threshold and respiration of true time</li>" +
          "<li><strong>Conscience vibratoire</strong> — calibration of the accord between body, perception, and milieu</li>" +
        "</ul>",
      cta_translate: "Proposer une traduction du concept"
    },
    es: {
      title: "Humanus",
      kicker: "Unidad de conciencia en sintonía con lo vivo — interfaz captora–difusora del paso.",
      title_img: { src: HUMANUS_CONCEPT_URL, alt: "Idéogramme conceptuel de Humanus" },
      h_def: "Definición canónica",
      chip_1: "Ideograma funcional",
      chip_1_img: { src: HUMANUS_FUNCTION_URL, alt: "Idéogramme fonctionnel de Humanus" },
      chip_2: "Función posœnnoïal",
      chip_2_img: { src: HUMANUS_POFUNCTION_URL, alt: "Fonction posœnnoïale de Humanus" },
      chip_3: "",
      chip_3_img: { src: "", alt: "" },
      def_short: "El <strong>Humanus</strong> designa la unidad de conciencia en sintonía con lo vivo, atravesada por la luz como onda operativa.",
      def_long:
        "<p><strong>Humanus</strong> nombra al humano como interfaz captora–difusora. La percepción no es allí una recepción pasiva: ya constituye un paso. La respiración no es allí una mera necesidad biológica: se vuelve un acto de redistribución. Ver ya es ser atravesado, respirar es modular y transmitir.</p>" +
        "<p>En K9, <strong>Humanus</strong> aparece como lugar de inscripción del tiempo verdadero: la luz recibida se deposita allí como fragmento de temporalidad justa, a sostener sin apropiación ni rigidificación. En una obra, un texto, una interfaz o una práctica, desplaza el centro de lectura: ya no se opera sobre lo humano, sino desde lo humano como zona de paso.</p>",
      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Concepto (K9 – Fundamentos)",
      grid_freq_label: "Número-guía",
      grid_freq_value: "—",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
          "<li>Percepción como interfaz del paso</li>" +
          "<li>Respiración como redistribución y sostén</li>" +
          "<li>Inscripción del tiempo verdadero en el cuerpo y la conciencia</li>" +
          "<li>Gesto simple de sostén para volver habitable la transformación</li>" +
          "<li>Uso en la obra, el texto, la interfaz y la práctica</li>" +
        "</ul>",
      h_intro: "Lo que nombra Humanus",
      p_intro:
        "<p><strong>Humanus</strong> designa al humano como interfaz captora–difusora. Ojo, escucha, atención, tacto y respiración se vuelven instrumentos de ajuste: ver equivale a ser atravesado, respirar equivale a modular y transmitir.</p>" +
        "<p>El término se conserva en su forma latina para marcar un desplazamiento decisivo: no se trata de una definición abstracta de lo humano, sino de una tenida operativa de la experiencia vivida, donde luz, ritmo y conciencia se vuelven paso.</p>" +
        "<p>En la lógica de <strong>Humanus humanitas</strong>, la singularidad vivida y el horizonte colectivo se encuentran en una misma habitación de lo vivo.</p>",
      h_actions: "Funcionamiento operativo",
      actions:
        "<ol>" +
          "<li>Reconocer el punto de percepción que sirve de interfaz al paso: ojo, escucha, tacto, atención.</li>" +
          "<li>Reconocer el ritmo que vuelve habitable la transformación: respiración, cadencia, pausa, densidad.</li>" +
          "<li>Recibir el fragmento de luz-tiempo sin fijarlo: acoger lo que atraviesa sin apropiación.</li>" +
          "<li>Elegir un gesto simple de sostén: frase, forma, ajuste, acto breve, postura o respiración orientada.</li>" +
          "<li>Redistribuir lo recibido en la conciencia, el cuerpo, la relación o la obra para que el paso siga siendo practicable.</li>" +
        "</ol>",
      h_phrase: "Frase operativa",
      phrase: "<p>« Humanus: percibo, respiro, y el paso se vuelve habitable. »</p>",
      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Acción de Humanus",
      table_rows:
        "<tr><td>Paso interior por sostener</td><td>Emoción, luz, memoria o claridad en depósito</td><td>Transformar la recepción en respiración y la respiración en sostén</td></tr>" +
        "<tr><td>Lectura de una obra o de un texto</td><td>Mirada descentrada, aparición de un umbral sensible</td><td>Operar desde lo humano como interfaz de paso</td></tr>" +
        "<tr><td>Tiempo vivido en desequilibrio</td><td>Compresión, saturación, exceso de intensidad o dispersión</td><td>Volver habitable el paso por el ritmo, la respiración y el ajuste</td></tr>" +
        "<tr><td>Trabajo corporal o meditativo</td><td>Necesidad de reajustar percepción, respiración y conciencia</td><td>Hacer de la respiración un instrumento de ajuste y redistribución</td></tr>",
      h_entite: "Vínculos internos",
      entite_kicker: "Entrada contenida en Âṣẹxel’Or",
      entite_body:
        "<p><strong>Humanus</strong> mantiene vínculos directos con <strong>Âṣẹxel’Or</strong>, <strong>Souffle d’Or</strong>, <strong>Δτ</strong>, <strong>Numéris</strong> y el <strong>Année posœnnoïale</strong> (<strong>AP</strong>). En esta constelación, la respiración porta el paso, el umbral temporal lo regula, el número ofrece una lectura frecuencial y el ciclo inscribe la experiencia en la práctica.</p>" +
        "<p>El eje es claro: <strong>Souffle d’Or</strong> respira, <strong>Humanus</strong> habita; <strong>Δτ</strong> abre el umbral, <strong>Humanus</strong> lo sostiene; <strong>Numéris</strong> mide, <strong>Humanus</strong> resuena; el <strong>Année posœnnoïale</strong> estructura, <strong>Humanus</strong> encarna.</p>",
      h_ritual: "Micro-ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Percepción – respiración – gesto de sostén",
      ritual_steps:
        "<ol>" +
          "<li>Situarse en un momento de claridad sensible, trastorno, viraje o recepción.</li>" +
          "<li>Nombrar en silencio el punto de percepción activo: mirada, escucha, piel, respiración, atención.</li>" +
          "<li>Inspirar lentamente, dejando entrar el fragmento recibido sin juzgarlo ni cerrarlo.</li>" +
          "<li>Expirar eligiendo un gesto simple de sostén: una frase, una nota, un trazo, un ajuste, una orientación del cuerpo.</li>" +
          "<li>Cerrar con la frase operativa para que el paso se vuelva habitable y no aplastante.</li>" +
        "</ol>",
      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
          "<li>Lectura de un texto o de una obra donde algo pide ser recibido antes de ser analizado</li>" +
          "<li>Estados de saturación, deslumbramiento, trastorno o densificación interior</li>" +
          "<li>Trabajo sobre la respiración como principio de redistribución</li>" +
          "<li>Fases de ajuste entre percepción, cuerpo, ritmo y conciencia</li>" +
          "<li>Pasajes donde se busca menos definir lo humano que habitarlo como umbral</li>" +
        "</ul>",
      h_syntony: "Sintonías Katûvýsiennes",
      syntony:
        "<ul>" +
          "<li><strong>Katûvýs</strong> — matriz-sustrato donde bañan las intensidades recibidas</li>" +
          "<li><strong>Katûvýsissence</strong> — memoria de la travesía y depósito de los ajustes</li>" +
          "<li><strong>Méditations Posœnnoïales</strong> — ejercicio de claridad íntima e integración de la respiración</li>" +
          "<li><strong>Accords Posœnnoïaux</strong> — inscripción relacional y colectiva de la experiencia</li>" +
          "<li><strong>Numéris</strong> — lectura frecuencial de lo vivido</li>" +
          "<li><strong>Δτ</strong> — sostén del umbral y respiración del tiempo verdadero</li>" +
          "<li><strong>Conscience vibratoire</strong> — calibración del acuerdo entre cuerpo, percepción y medio</li>" +
        "</ul>",
      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", normLang(lang) || "fr");
    } catch (e) {}
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */
  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    activeKey: "",
    activeButtons: []
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function getAudioUILabels(lang) {
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function stopAudio() {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    for (var i = 0; i < PO_AUDIO_STATE.activeButtons.length; i++) {
      try { PO_AUDIO_STATE.activeButtons[i].setAttribute("data-po-audio-state", "idle"); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.activeButtons = [];
  }

  function setAudioButtonsState(root, lang, activeKey) {
    var labels = getAudioUILabels(lang);
    var all = root.querySelectorAll(".po-audio-btn");
    PO_AUDIO_STATE.activeButtons = [];
    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      var kind = btn.getAttribute("data-po-audio-kind") || "block";
      var key = btn.getAttribute("data-po-audio-key") || "";
      var active = !!activeKey && key === activeKey;
      btn.setAttribute("data-po-audio-state", active ? "playing" : "idle");
      btn.textContent = active ? labels.stop : (kind === "general" ? labels.general : labels.block);
      if (active) PO_AUDIO_STATE.activeButtons.push(btn);
    }
  }

  function audioTextFromNode(node) {
    if (!node) return "";
    var clone = node.cloneNode(true);
    var junk = clone.querySelectorAll(".po-audio-btn, script, style");
    for (var i = 0; i < junk.length; i++) {
      if (junk[i] && junk[i].parentNode) junk[i].parentNode.removeChild(junk[i]);
    }
    var txt = "";
    try { txt = clone.innerText || clone.textContent || ""; } catch (e) { txt = clone.textContent || ""; }
    return clampStr(txt).replace(/\s+/g, " ").replace(/\s([,;:.!?])/g, "$1").trim();
  }

  function splitTextForSpeech(text) {
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?]+[.!?…]?/g) || [src];
    var maxLen = 210;
    var out = [];
    var cur = "";
    for (var i = 0; i < parts.length; i++) {
      var piece = clampStr(parts[i]).trim();
      if (!piece) continue;
      if (!cur) {
        cur = piece;
        continue;
      }
      if ((cur + " " + piece).length <= maxLen) cur += " " + piece;
      else {
        out.push(cur);
        cur = piece;
      }
    }
    if (cur) out.push(cur);
    return out;
  }

  function ensureDetailsOpen(details) {
    if (!details) return;
    try { details.open = true; } catch (e) {}
  }

  function getRootGeneralText(root) {
    var keys = ["title", "kicker", "h_def", "def_short", "def_long"];
    var chunks = [];
    for (var i = 0; i < keys.length; i++) {
      var el = root.querySelector('[data-po-slot="' + keys[i] + '"]');
      var txt = audioTextFromNode(el);
      if (txt) chunks.push(txt);
    }
    return chunks.join(" ");
  }

  function getBlockText(details) {
    if (!details) return "";
    var summary = details.querySelector(".po-lex-summary");
    var bodyParts = [];
    var title = audioTextFromNode(summary);
    if (title) bodyParts.push(title);
    var children = details.children;
    for (var i = 0; i < children.length; i++) {
      if (children[i].tagName && children[i].tagName.toLowerCase() === "summary") continue;
      var txt = audioTextFromNode(children[i]);
      if (txt) bodyParts.push(txt);
    }
    return bodyParts.join(" ");
  }

  function buildAudioUnits(root, startIndex) {
    var units = [];
    if (startIndex === 0) {
      var general = getRootGeneralText(root);
      if (general) units.push({ key: "general", text: general });
    }
    var details = root.querySelectorAll(".po-lex-details");
    for (var i = startIndex; i < details.length; i++) {
      var txt = getBlockText(details[i]);
      if (!txt) continue;
      units.push({ key: "block-" + i, text: txt, details: details[i] });
    }
    return units;
  }

  function speakChunks(lang, chunks, onDone) {
    if (!PO_AUDIO_SYNTH || !chunks.length) {
      if (typeof onDone === "function") onDone();
      return;
    }

    var voices = [];
    try { voices = PO_AUDIO_SYNTH.getVoices() || []; } catch (e) { voices = []; }
    var langTag = normLang(lang) || "fr";
    var preferred = { fr: "fr-FR", en: "en-US", es: "es-ES" }[langTag] || "fr-FR";
    var voice = null;

    for (var i = 0; i < voices.length; i++) {
      var vl = (voices[i].lang || "").toLowerCase();
      if (vl.indexOf(langTag) === 0) { voice = voices[i]; break; }
    }

    function next(idx) {
      if (idx >= chunks.length) {
        if (typeof onDone === "function") onDone();
        return;
      }
      var utter = new SpeechSynthesisUtterance(chunks[idx]);
      utter.lang = preferred;
      if (voice) utter.voice = voice;
      utter.rate = 0.98;
      utter.pitch = 1;
      utter.onend = function () { next(idx + 1); };
      utter.onerror = function () { next(idx + 1); };
      try { PO_AUDIO_SYNTH.speak(utter); } catch (e) { next(idx + 1); }
    }

    next(0);
  }

  function playAudioUnits(root, lang, units, activeKey) {
    if (!units || !units.length) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = units.slice();
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.activeKey = activeKey || units[0].key;
    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);

    function advance() {
      if (!PO_AUDIO_STATE.units.length || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      setAudioButtonsState(root, lang, unit.key);
      if (unit.details) ensureDetailsOpen(unit.details);
      var chunks = splitTextForSpeech(unit.text);
      speakChunks(lang, chunks, function () {
        PO_AUDIO_STATE.unitPos += 1;
        advance();
      });
    }

    advance();
  }

  function makeAudioButton(kind, key, lang) {
    var labels = getAudioUILabels(lang);
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-audio-btn notranslate";
    btn.setAttribute("translate", "no");
    btn.setAttribute("data-po-audio-kind", kind);
    btn.setAttribute("data-po-audio-key", key);
    btn.setAttribute("data-po-audio-state", "idle");
    btn.textContent = kind === "general" ? labels.general : labels.block;
    return btn;
  }

  function injectAudioButtons(root, lang) {
    if (!root) return;

    var old = root.querySelectorAll(".po-audio-btn");
    for (var i = 0; i < old.length; i++) {
      if (old[i] && old[i].parentNode) old[i].parentNode.removeChild(old[i]);
    }

    var generalBtn = makeAudioButton("general", "general", lang);
    var meta = root.querySelector(".po-axis-meta");
    var defShort = root.querySelector('[data-po-slot="def_short"]');
    var firstDetails = root.querySelector(".po-lex-details");

    if (meta && meta.parentNode) meta.parentNode.insertBefore(generalBtn, meta.nextSibling);
    else if (defShort && defShort.parentNode) defShort.parentNode.insertBefore(generalBtn, defShort);
    else if (firstDetails && firstDetails.parentNode) firstDetails.parentNode.insertBefore(generalBtn, firstDetails);

    generalBtn.addEventListener("click", function () {
      if (PO_AUDIO_STATE.activeKey === "general") {
        stopAudio();
        setAudioButtonsState(root, lang, "");
        return;
      }
      playAudioUnits(root, lang, buildAudioUnits(root, 0), "general");
    });

    var details = root.querySelectorAll(".po-lex-details");
    for (var j = 0; j < details.length; j++) {
      var summary = details[j].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = makeAudioButton("block", "block-" + j, lang);
      btn.addEventListener("click", (function (idx) {
        return function (ev) {
          try { ev.preventDefault(); ev.stopPropagation(); } catch (e) {}
          var key = "block-" + idx;
          if (PO_AUDIO_STATE.activeKey === key) {
            stopAudio();
            setAudioButtonsState(root, lang, "");
            return;
          }
          playAudioUnits(root, lang, buildAudioUnits(root, idx), key);
        };
      })(j));
      summary.appendChild(btn);
    }

    setAudioButtonsState(root, lang, PO_AUDIO_STATE.activeKey);
  }

  function initAudioEverywhere(lang) {
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      injectAudioButtons(roots[i], lang || getLang());
    }
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "table_rows",
      "entite_body", "ritual_steps", "moments", "syntony", "phrase"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    for (var key in c) {
      if (!Object.prototype.hasOwnProperty.call(c, key)) continue;
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) continue;

      if (imgSlots.indexOf(key) > -1) { setImg(el, c[key]); continue; }
      if (htmlSlots.indexOf(key) > -1) { setHTML(el, c[key]); continue; }
      setText(el, c[key]);
    }

    toggleTitleMedia(root);
    toggleChipBlocks(root);
    applyLangbar(root, lang);
  }

  function setLang(lang) {
    var safeLang = storeLang(normLang(lang) || "fr");
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    initAudioEverywhere(safeLang);
    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK5HumanusInit) return;
    root.__poK5HumanusInit = true;
    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(lang);
  }

  window.PoK5HumanusTextsFR_EN_ES_20260319 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function () {
    try {
      __PO_PROTECT_RE__ = null;
      setLang(getLang());
    } catch (e) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
